import Vue from 'vue'

// TODO Vue.http.headers.common['Authorization'] = 'Basic YXBpOnBhc3N3b3Jk';

export default store => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'GET_AUTH_TOKEN') {
      window.localStorage.setItem('AUTH_TOKEN', mutation.payload)
      Vue.http.interceptors.push((request, next) => {
        request.headers.Authorization = 'Bearer ' + mutation.payload
        next()
      })
    }
    if (mutation.type === 'DELETE_AUTH_TOKEN') {
      window.localStorage.removeItem('AUTH_TOKEN')
    }
  })
}



// WEBPACK FOOTER //
// ./src/vuex/plugins/auth.js